export const rulesProfileDashboard = [
    { status: "draft", title: 'Respondente', language: "pt-BR", rules: [1, 2, 3]},
    { status: "approval_esg", title: 'Aprovação líder ESG',  language: "pt-BR", rules: [1, 2, 3]},
    { status: "evaluation_avesso", title: 'Avaliação avesso', language: "pt-BR", rules: [1, 2, 3 ,4]  },
    { status: "evaluation_suzano",  title: 'Avaliação suzano', language: "pt-BR",  rules: [1, 2, 3, 5]},
    { status: "finished", title: 'Publicado',  language: "pt-BR",  rules: [1, 2, 3, 7] },
    { status: "draft_en", title: 'Tradutor', language: "en-US",  rules: [1, 6] },
    { status: "evaluation_suzano_en", title: 'Avaliação suzano', language: "en-US", rules: [1, 5, 6] },
    { status: "finished_en", title: 'Publicado', language: "en-US", rules: [1, 6] },
]


export const rulesAdvanceStatus = [
    { id: 1, title: 'Respondente', status: 'draft', allowedProfiles: [1, 3] },
    { id: 2, title: 'Aprovação líder ESG', status: 'approval_esg', allowedProfiles: [1, 2] },
    { id: 3, title: 'Avaliação avesso', status: 'evaluation_avesso', allowedProfiles: [1, 4] },
    { id: 4, title: 'Avaliação suzano', status: 'evaluation_suzano', allowedProfiles: [1, 5] },
    { id: 5, title: 'Publicado', status: 'finished', allowedProfiles: [1] },
    { id: 6, title: 'Tradutor', status: 'draft_en', allowedProfiles: [1, 6] },
    { id: 7, title: 'Avaliação suzano', status: 'evaluation_suzano_en', allowedProfiles: [1, 5] },
    { id: 8, title: 'Publicado', status: 'finished_en', allowedProfiles: [1] },
];